import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import role from './modules/role'
import item from './modules/item'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    role,
    item
  }
})

export default store



// WEBPACK FOOTER //
// ./examples/store/index.js